export default __webpack_public_path__ + "static/media/Version (6) - Ultimate Map_28.6630e5c6.jpg";